import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

interface ModalProps {
  title: string;
  isVisible: boolean;
  onPress: () => void;
}

const CustomModal: React.FC<ModalProps> = ({ title, isVisible, onPress }) => {
  return (
    <Dialog
      open={isVisible}
      onClose={onPress}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      PaperProps={{ style: { padding: "20px", borderRadius: 10 } }}
    >
      <DialogContent>
        <CheckCircleOutlineIcon
          color="primary"
          style={{
            fontSize: 70,
            display: "block",
            margin: "0 auto",
            marginBottom: 20,
          }}
        />
        <Typography
          variant="body1"
          id="modal-title"
          style={{ textAlign: "center", marginBottom: 20 }}
        >
          {title}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          <Button onClick={onPress} color="primary" variant="contained">
            Aceptar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
